import React from 'react';
import {DateUtil} from "@/utils/dateUtil.ts";
import {PrintUtil} from "@/utils/printUtil.ts";

interface InvoiceContentProps {
  data: any;
  translations: any;
  language: string;
  clinicInfo: any;
  doctorInfo: any;
  patientInfo: any;
  settings: any;
  currentUser: any;
}

export function InvoiceContent({
                                 data,
                                 translations: t,
                                 language,
                                 clinicInfo,
                                 doctorInfo,
                                 patientInfo,
                                 settings,
                                 currentUser,
                               }: InvoiceContentProps) {

  // Format currency with Indian Rupee symbol
  const formatCurrency = (amount: number | string | null | undefined) => {
    // Convert to number in case MySQL returns string (DECIMAL type)
    const numAmount = Number(amount || 0);
    return `₹${numAmount.toFixed(2)}`;
  };

  const invoiceDate = new Date().toISOString(); // Default to current date/time

  return (
      <>
      {/* Header with Clinic Info */}
        <div style={{
          textAlign: 'center',
          marginBottom: '8mm',
          paddingBottom: '5mm',
          // borderBottom: '2px solid #000'
        }}>
          <div style={{fontSize: '18px', fontWeight: 'bold', marginBottom: '2mm'}}>
            {clinicInfo?.name}
          </div>
          <div style={{fontSize: '11px', marginBottom: '1mm'}}>
            {clinicInfo?.address}
          </div>
          {/*<div style={{ fontSize: '11px', marginBottom: '1mm' }}>*/}
          {/*  {t.phone}: {clinicInfo?.phone} | {t.email}: {clinicInfo?.email}*/}
          {/*</div>*/}
          <div style={{fontSize: '14px', fontWeight: 'bold', marginTop: '3mm'}}>
            Invoice
          </div>
        </div>

      {/* Invoice Details & Patient Info */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '10mm',
          marginBottom: '8mm',
          fontSize: '11px'
        }}>
          {/* Left - Invoice Info */}
          <div>
            <div style={{marginBottom: '2mm'}}>
              <span
                  style={{fontWeight: 'bold'}}>MRN:</span> {patientInfo?.mrn || data?.patient_mrn || 'N/A'}
            </div>
            <div style={{marginBottom: '2mm'}}>
              <span
                  style={{fontWeight: 'bold'}}>Invoice No:</span> {data?.invoice_number || data?.id}
            </div>
            <div style={{marginBottom: '2mm'}}>
              <span style={{fontWeight: 'bold'}}>Invoice Date:</span> {DateUtil.formatDateForType(invoiceDate, 'date-time')}
            </div>
            <div style={{marginBottom: '2mm'}}>
              <span
                  style={{fontWeight: 'bold'}}>Consultant:</span> Dr. {doctorInfo?.name || data?.doctor_name}
            </div>
          </div>

          {/* Right - Patient Info */}
          <div>
            <div style={{marginBottom: '2mm'}}>
              <span
                  style={{fontWeight: 'bold'}}>Patient Name:</span> {PrintUtil.toUpperCaseText(patientInfo?.name) || PrintUtil.toUpperCaseText(patientInfo?.patient_name)}
            </div>

            <div style={{marginBottom: '2mm'}}>
              <span
                  style={{fontWeight: 'bold'}}>Age / Gender:</span> {PrintUtil.generateAgeGenderString(patientInfo)}
            </div>
            <div style={{marginBottom: '2mm'}}>
              <span
                  style={{fontWeight: 'bold'}}>Phone:</span> {patientInfo?.phone || data?.patient_phone}
            </div>

            <div style={{marginBottom: '2mm'}}>
              <span style={{fontWeight: 'bold'}}>Visit Date:</span> {DateUtil.formatDateForType(invoiceDate, 'date-time')}
            </div>

          </div>
        </div>

      {/* Services/Items Table */}
      {data?.items && data.items.length > 0 && (
          <div style={{marginBottom: '8mm'}}>
            <div style={{fontWeight: 'bold', marginBottom: '3mm', fontSize: '12px'}}>
              {t.service} & {t.charges}
            </div>

            {/* Table Header */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: '6% 40% 15% 10% 14% 15%',
              backgroundColor: '#f8f9fa',
              border: '1px solid #000',
              padding: '3mm',
              fontSize: '10px',
              fontWeight: 'bold'
            }}>
              <div style={{textAlign: 'left'}}>#</div>
              <div style={{textAlign: 'left'}}>{t.service}</div>
              <div style={{textAlign: 'left'}}>{t.category}</div>
              <div style={{textAlign: 'left'}}>{t.quantity}</div>
              <div style={{textAlign: 'left'}}>{t.unitPrice}</div>
              <div style={{textAlign: 'left'}}>{t.totalAmount}</div>
            </div>

            {/* Table Rows */}
            {data.items.map((item: any, index: number) => (
                <div key={index} style={{
                  display: 'grid',
                  gridTemplateColumns: '6% 40% 15% 10% 14% 15%',
                  border: '1px solid #ccc',
                  borderTop: 'none',
                  padding: '2mm',
                  fontSize: '10px'
                }}>
                  <div>{index + 1}</div>
                  <div style={{fontWeight: 'bold'}}>{item.service_name || item.name}</div>
                  <div style={{textTransform: 'capitalize'}}>{item.category || 'Service'}</div>
                  <div style={{textAlign: 'left'}}>{item.quantity || 1}</div>
                  <div
                      style={{textAlign: 'left'}}>{formatCurrency(item.price || item.unit_price || 0)}</div>
                  <div style={{
                    textAlign: 'left',
                    fontWeight: 'bold'
                  }}>{formatCurrency((item.quantity || 1) * (item.price || item.unit_price || 0))}</div>
                </div>
            ))}
          </div>
      )}

      {/* Payment Summary */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 200px',
          gap: '8mm',
          marginBottom: '8mm'
        }}>
          {/* Left side - Payment Method & Notes */}
          <div style={{fontSize: '11px'}}>

            {data?.notes && (
                <div>
                  <span style={{fontWeight: 'bold'}}>Notes:</span>
                  <div style={{marginTop: '1mm', color: '#555'}}>{data.notes}</div>
                </div>
            )}
          </div>

          {/* Right side - Amount Breakdown */}
          <div style={{fontSize: '11px'}}>
            <div style={{
              // border: '1px solid #000',
              padding: '3mm'
            }}>
              <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '2mm'}}>
                <span>{t.subtotal}:</span>
                <span
                    style={{fontWeight: 'bold'}}>{formatCurrency(data?.total_amount || 0)}</span>
              </div>


              <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: '2mm',
              }}>
                <span>Discount:</span>
                <span
                    style={{fontWeight: 'bold'}}>{formatCurrency(data?.discount_amount)}</span>
              </div>


              {data?.tax_amount && data.tax_amount > 0 && (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '2mm'
                  }}>
                    <span>Tax:</span>
                    <span style={{fontWeight: 'bold'}}>{formatCurrency(data?.tax_amount)}</span>
                  </div>
              )}

              <div style={{
                borderTop: '1px solid #000',
                paddingTop: '2mm',
                marginTop: '2mm',
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: '12px',
                fontWeight: 'bold'
              }}>
                <span>{t.total}:</span>
                <span>{formatCurrency(data?.total_amount || 0)}</span>
              </div>

            </div>
          </div>
        </div>

      {/* Footer */}

        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '10mm',
          fontSize: '10px'
        }}>
          <div>
            <span style={{fontWeight: 'bold', marginBottom: '5mm'}}>Generated By </span>
            <span style={{padding: '3mm'}}>{currentUser?.name}</span>
          </div>

          <div style={{textAlign: 'right'}}>
            <div>
              <span style={{fontWeight: 'bold', marginBottom: '3mm'}}>Generated On </span>
              <span
                  style={{padding: '3mm'}}>{DateUtil.formatDateForType(invoiceDate, 'date-time')}</span>
            </div>
          </div>

        </div>
      </>
  );
}